// extracted by mini-css-extract-plugin
export default {"tooltip":"WQ-z","arrow":"XQ-z"};